<template>
    <div class="gray-back">
      <div class="mine-box-title">已有单位绑定</div>
      <div class="mine-content">
        <div class="flex-between mine-li">
          <div class="flex-start">
            <div class="info-row-title">已有单位绑定</div>
          </div>
          <div class="flex-start">
            <div class="tishi">单位已在CCA官网备案，请输入原系统账号密码绑定。</div>
            <el-link type="primary" v-rblink="{name:'CertDanweiBind'}">去绑定</el-link>
          </div>
        </div>
        <div class="flex-between mine-li">
          <div class="flex-start">
            <div class="info-row-title">新增单位备案</div>
          </div>
          <div class="flex-start">
            <div class="tishi">单位还尚未在CCA官网备案，请提交单位信息备案</div>
            <el-link type="primary" v-rblink="{name:'CertDanweiApply'}">备案</el-link>
          </div>
        </div>
      </div>
        <van-cell-group v-if="false">
            <van-cell title="已有单位绑定" v-rblink="{name:'CertDanweiBind','query':{ }}"  label="单位已在CCA官网备案，请输入原系统账号密码绑定。">
                <template #right-icon>
                    <div class="tiny-btn-1">去绑定</div>
                </template> 
            </van-cell>
            <van-cell title="新增单位备案" v-rblink="{name:'CertDanweiApply','query':{ }}" label="单位还尚未在CCA官网备案，请提交单位信息备案">
                <template #right-icon>
                    <div class="tiny-btn-1">备案</div>
                </template>
            </van-cell>

        </van-cell-group>



    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }


    .bottom-button{
        margin-top: 0.2rem;
        margin-bottom: 0.2rem;
        width: 100%;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
    }

    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'CertDanwei',
        components: {
            PicUploader,
        },
        data: function () {
            return {
                validator,
                saveLoading:false,
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                formData: {
                    id: 0,
                    areas:'',
                    province:'',
                    city:'',
                    county:'',
                    kaojitype:'考级中心',
                    changdipic: [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
                    zhizhaopic: [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
                },
            }
        },
        filters: {},
        mounted() {
            let that = this;
            document.title="单位备案"
            that.areaList = area;
            that.formData.id = this.$route.query.id;
            if(that.formData.id){
                this.fetch();
            }
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            },

        }
    }
</script>



// WEBPACK FOOTER //
// CertDanwei.vue?10eb3eb6